import { reactive } from 'vue'
import { isEmpty } from 'lodash'
import { browserLanguage, getLangTranslations, handlePlaceholder, selectedLanguage, t, te } from '@shared/plugins/i18n'

export default function useI18n() {
  const contentState = reactive({})

  // METHODS
  async function getContent({ app, language = selectedLanguage.value, languageChanged }) {
    let changed = false
    let content = {}

    if (languageChanged) {
      content = await updateTranslations({ app, language })
      changed = true
    } else {
      content = getLangTranslations(language) || {}
      changed = false

      if (!contentState[app]) {
        contentState[app] = true
        Object.assign(content, await loadContent(app, language))
        changed = true
      }
    }

    return {
      content,
      changed,
    }
  }

  async function loadContent(type, language) {
    return await import(`@shared/language/${type}/${type}.${language.toLowerCase()}.json`).then(res => res.default)
  }

  async function updateTranslations({ app, language = selectedLanguage.value }) {
    let content = getLangTranslations(language) || {}

    if (isEmpty(content) && contentState[app]) {
      Object.assign(content, await loadContent(app, language))
    }

    return content
  }

  function updateHtmlPageData({ language }) {
    // update html language attribute
    document.documentElement.setAttribute('lang', language)

    if (!te('meta')) {
      return
    }

    const meta = t('meta')

    // check, if DVP-"app" is present
    if (document.querySelector('body[data-track-app=DVP]')) {
      document.querySelector('title').innerText = [import.meta.env.VITE_PAGE_TITLE_PREFIX, meta.title]
        .filter(x => !!x)
        .join(' ')
      document.querySelector('meta[name=description]').content = meta.description
    }
  }

  return {
    browserLanguage,
    getContent,
    updateHtmlPageData,
    handlePlaceholder,
    selectedLanguage,
    t,
    te,
  }
}
